<mat-tab-group>
  <mat-tab label="Summary">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      <div fxLayout="row" fxLayoutAlign="start start" class="summary-title">
        Phase Spread
      </div>
      <div fxLayout="row" fxLayoutGap="16px">
        <div id="pie"></div>
        <div fxLayout="column">
          <div class="legend">
            <div *ngFor="let key of colorsArray">
              <span class="legend_color" [ngStyle]="{ 'background-color': colors[key].color }"></span>
              {{ colors[key].name }}
            </div>
            <div *ngIf="showNone">
              <span class="legend_color" [ngStyle]="{ 'background-color': noneColor }"></span>
              None
            </div>
          </div>
          <div fxFlex></div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Library">
      <div mat-dialog-content fxLayout="column">
        <mat-form-field fxFlex>
          <input type="text" matInput placeholder="Filter..." [(ngModel)]="searchText" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <mat-list class="item-list" dense>
          <mat-list-item *ngFor="let item of libraryItems | filterUserLibrary: searchText">
            <template-library-item matLine [label]="item.type" [title]="item.item.name" >
              <button  mat-icon-button [matMenuTriggerFor]="libraryItemMenu" class="legend_color">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #libraryItemMenu>
                <button mat-menu-item disabled (click)="previewLibrary(item)">
                  <mat-icon>visibility</mat-icon>
                  <span>Preview</span>
                </button>
                <button mat-menu-item disabled (click)="shareLibrary(item)">
                  <mat-icon>send</mat-icon>
                  <span>Share</span>
                </button>
                <button mat-menu-item (click)="deleteLibrary(item)">
                  <mat-icon>delete</mat-icon>
                  <span>Remove</span>
                </button>
              </mat-menu>
            </template-library-item>
            </mat-list-item>
        </mat-list>
      </div>
  </mat-tab>
</mat-tab-group>